import AEPOverview from 'quality/components/AEPoverview/AEPOverview'
import React, { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import useTitle from 'utils/customHook/useTitle'
import { getStationTitleWithTownName } from 'utils/StationUtils'
import i18n from 'simple-react-i18n'
import { useParams } from 'react-router'

const InstallationAEPApp = () => {
    const { id } = useParams()

    const {
        installation,
        associatedSites,
        citiesIndex,
    } = useSelector(store => ({
        installation: store.InstallationReducer.installation,
        associatedSites: store.StationReducer.associatedSites,
        citiesIndex: store.CityReducer.citiesIndex,
    }), shallowEqual)

    const townName = useMemo(() => citiesIndex[installation.townCode]?.name, [citiesIndex, installation])

    useTitle(() => [{
        title: i18n.installation,
        href: 'installation',
    }, {
        title: getStationTitleWithTownName(installation, townName),
        href: `station/installation/${id}`,
    }, {
        title: i18n.AEPoverview,
        href: `station/installation/${id}/conformityOverview`,
    }], [installation, townName])

    const ids = useMemo(() => associatedSites.filter(site => site.stationLinkedType === 3).map(site => site.stationLinkedId), [associatedSites])

    return (
        <AEPOverview
            ids={ids}
        />
    )
}

export default InstallationAEPApp